<template>
  <div
    class="organization-profile"
    v-if="isAdmin">
    <div class="card">
      <div class="card-header">
        <h3>Editar dados da Organização</h3>
      </div>
      <div class="card-body">
        <form
          ref="editOrganizationForm"
          class="text-center"
          @submit.prevent="onSubmit"
          @keydown.enter.prevent="onSubmit">
          <ErrorAlert :error="error" :centered="true" />
          <div class="form-group row">
            <label
              for="name"
              class="col-sm-4 col-form-label">Nome</label>
            <div class="col-sm-8">
              <input
                id="name"
                type="text"
                class="form-control organization-name"
                v-model="name"
                required>
            </div>
          </div>
          <div class="form-group row">
            <label
              for="email"
              class="col-sm-4 col-form-label">Email</label>
            <div class="col-sm-8">
              <input
                id="email"
                type="text"
                class="form-control organization-email"
                v-model="email"
                required>
            </div>
          </div>
          <div class="form-group row">
            <label
              for="phone"
              class="col-sm-4 col-form-label">Telefone</label>
            <div class="col-sm-8">
              <input
                id="phone"
                type="text"
                class="form-control organization-phone"
                placeholder="(00) 00000-0000"
                maxlength="15"
                v-model="phoneDisplay"
                @keydown="allowOnlyNumericKeydown">
            </div>
          </div>
          <div class="buttons flex">
            <button
              type="submit"
              class="btn btn-primary organization-save"
              @click.prevent="onSubmit">
              Atualizar
            </button>
          </div>
        </form>
      </div>
    </div>
    <div
      class="modal fade"
      tabindex="-1"
      role="dialog"
      id="editOrganizationSuccess"
      ref="editOrganizationSuccess"
      data-keyboard="false"
      data-backdrop="static"
      aria-hidden="true">
      <div
        class="modal-dialog modal-dialog-centered"
        role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              @click.prevent="onModalOk"
              aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body text-center">
            <h5>Dados da Organização atualizados com sucesso!</h5>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-outline-secondary"
              @click.prevent="onModalOk">OK</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import loopback from '@/services/loopback'
import { formatPhoneMask, phoneDigitsOnly, phoneToNationalDisplay, allowOnlyNumericKeydown } from '@/utils/phone'

export default {
  name: 'OrganizationProfile',
  data () {
    return {
      name: null,
      email: null,
      phone: '',
      error: null
    }
  },
  computed: {
    isAdmin () {
      return this.$store.state.auth.user && this.$store.state.auth.user.role === 'ADMIN'
    },
    phoneDisplay: {
      get () {
        return formatPhoneMask(this.phone || '')
      },
      set (value) {
        this.phone = phoneDigitsOnly(value)
      }
    }
  },
  mounted () {
    this.$nextTick(function () {
      this.getOrganization()
    })
  },
  methods: {
    allowOnlyNumericKeydown,
    onSubmit () {
      const form = this.$refs.editOrganizationForm
      this.error = null
      if (form.checkValidity()) {
        const paramsToUpdate = {
          name: this.name,
          email: this.email,
          phone: this.phone || null
        }
        loopback
          .patch('/accounts', paramsToUpdate)
          .then(organization => {
            this.$store.commit('auth/setOrganization', organization)
            this.setOrganization(organization)
            $(this.$refs.editOrganizationSuccess).modal('show')
          })
          .catch(err => {
            this.error = err
            // TEL-2243: o `friendly` do interceptor ja resolve `details.messages` pelo
            // FIELD_MESSAGES, mantem em pt-BR o que o backend ja manda traduzido e nomeia
            // o campo quando nao ha texto proprio. Montar `lines` aqui devolvia o texto do
            // LoopBack em ingles e ainda sobrescrevia a traducao.
          })
      } else {
        this.error = {
          message: 'O campo nome e email são obrigatórios'
        }
      }
    },
    getOrganization () {
      this.error = null
      const organization = this.$store.state.auth.organization
      if (organization) {
        this.setOrganization(organization)
      }
    },
    setOrganization (organization) {
      this.name = organization.name
      this.email = organization.email
      this.phone = organization.phone ? phoneToNationalDisplay(String(organization.phone)) : ''
    },
    onModalOk () {
      this.$router.go(0)
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/Organization/Profile.vue